import {gsap} from "gsap";
import {Game} from "../Game";

export class WallClock extends PIXI.Container {
    private _hHand: PIXI.Sprite;
    private _mHand: PIXI.Sprite;
    private _sHand: PIXI.Sprite;
    private _center: PIXI.Sprite;
    private _clockTl: gsap.core.Timeline;
    private _flickerTl: gsap.core.Timeline | null;

    constructor() {
        super();
        this.init();
        this.name = "clockContainer";
    }

    public hide(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.clockStop();
        });
        tl.to(this, {duration: 0.001, alpha: 0});
        return tl;
    }

    public show(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.clockPlay();
        });
        tl.to(this, {duration: 0.001, alpha: 1});
        return tl;
    }

    public clockPlay() {
        this._clockTl = gsap.timeline({repeat: -1});
        this._clockTl.add(() => {
            const date: Date = new Date();
            const hours: number = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
            const minutes: number = date.getMinutes();
            const seconds: number = date.getSeconds();
            this._sHand.rotation = seconds * 6 * (Math.PI / 180);
            this._mHand.rotation = ((minutes + seconds / 60) * 6 - 90) * (Math.PI / 180);
            this._hHand.rotation = ((hours + minutes / 60) * 30 + 90) * (Math.PI / 180);
        })
        this._clockTl.to(this._sHand, {duration: 1});
    }

    public clockStop(): void {
        this._clockTl?.pause();
        this._clockTl?.kill();
    }

    public clockReverse(): void {
        let startCounter: number = 0;
        this.clockStop();
        this._clockTl = gsap.timeline({repeat: -1});
        this._clockTl.add(() => {
            const date: Date = new Date();
            const hours: number = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
            const minutes: number = date.getMinutes();
            let seconds: number = date.getSeconds();
            startCounter += 2;
            seconds -= startCounter;
            this._sHand.rotation = ((seconds) * (6) * (Math.PI / 180));
            this._mHand.rotation = ((minutes + seconds / 60) * (6) - 90) * (Math.PI / 180);
            this._hHand.rotation = ((hours + minutes / 60) * (30) + 90) * (Math.PI / 180);
        })
        this._clockTl.to(this._sHand, {duration: 1});
    }

    public clockSetOnTime(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const date: Date = new Date();
        const hours: number = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
        const minutes: number = date.getMinutes();
        const seconds: number = date.getSeconds() + 1;
        const hHandRotate: number = ((hours + minutes / 60) * 30 + 90) * (Math.PI / 180);
        const sHandRotate: number = ((seconds) * (6) * (Math.PI / 180));
        const mHandRotate: number = ((minutes + seconds / 60) * (6) - 90) * (Math.PI / 180);
        tl.to(this._sHand, {duration: 1, rotation: 2 * Math.PI + sHandRotate});
        tl.to(this._mHand, {duration: 1, rotation: 2 * Math.PI + mHandRotate}, "<");
        tl.to(this._hHand, {duration: 1, rotation: 2 * Math.PI + hHandRotate}, "<");
        tl.add(() => {
            this.clockStop();
            this.clockPlay();
        }, ">");
        return tl;
    }


    public playClockFlickerLeft() {
        const tl = gsap.timeline();
        tl.add(() => this.clockVisibility(0.2), 0);
        tl.add(() => this.clockVisibility(0.3), 1.6);
        tl.add(this.clockVisibilityWithTween(1, 1));//, 1.6667
        tl.play(0);
    }

    public playClockFlicker(isLoop: boolean = true) {
        this._flickerTl = gsap.timeline({
            onComplete: () => {
                isLoop ? this.clockFlickerStop() : this.playClockFlicker();
            }
        });
        this._flickerTl.add(() => this.clockVisibility(0.2), 0);
        this._flickerTl.add(() => this.clockVisibility(0.3), 0.0333);
        this._flickerTl.add(() => this.clockVisibility(0.4), 0.0667);
        this._flickerTl.add(() => this.clockVisibility(0.2), 0.1333);
        this._flickerTl.add(() => this.clockVisibility(0.15), 0.2);
        this._flickerTl.add(() => this.clockVisibility(0.15), 0.2667);
        this._flickerTl.add(() => this.clockVisibility(0.15), 0.3333);
        this._flickerTl.add(() => this.clockVisibility(0.2), 0.4);
        this._flickerTl.add(() => this.clockVisibility(0.2), 0.4333);
        this._flickerTl.add(() => this.clockVisibility(0.3), 0.4667);
        this._flickerTl.add(() => this.clockVisibility(0.2), 0.5);
        this._flickerTl.add(() => this.clockVisibility(0.2), 0.7);
        this._flickerTl.add(() => this.clockVisibility(0.35), 0.7333);
        this._flickerTl.add(() => this.clockVisibility(0.4), 0.7667);
        this._flickerTl.add(() => this.clockVisibility(0.5), 0.8333);
        this._flickerTl.add(() => this.clockVisibility(0.4), 0.8667);
        this._flickerTl.add(() => this.clockVisibility(0.3), 0.9);
        this._flickerTl.add(() => this.clockVisibility(0.2), 0.9333);
        this._flickerTl.add(() => this.clockVisibility(0.4), 0.9667);
        this._flickerTl.add(() => this.clockVisibility(0.2), 1);
        this._flickerTl.add(() => this.clockVisibility(0.2), 1.3667);
        this._flickerTl.add(() => this.clockVisibility(0.3), 1.4);
        this._flickerTl.add(() => this.clockVisibility(0.2), 1.4333);
        this._flickerTl.add(() => this.clockVisibility(0.2), 1.6667);
        this._flickerTl.play(0);
    }

    public clockFlickerStop() {
        this._flickerTl?.pause();
        this._flickerTl?.kill();
        this._sHand.alpha = 1;
        this._mHand.alpha = 1;
        this._hHand.alpha = 1;
        this._center.alpha = 1;
    }

    private clockVisibility(alpha: number): void {
        this._sHand.alpha = alpha;
        this._mHand.alpha = alpha;
        this._hHand.alpha = alpha;
        this._center.alpha = alpha;
    }

    private clockVisibilityWithTween(alpha: number, duration: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.to(this._sHand, {duration: duration, alpha: alpha}, 0);
        tl.to(this._mHand, {duration: duration, alpha: alpha}, 0);
        tl.to(this._hHand, {duration: duration, alpha: alpha}, 0);
        tl.to(this._center, {duration: duration, alpha: alpha}, 0);
        return tl;
    }

    private init(): void {
        this._center = new PIXI.Sprite(Game.assetLoader.getTextures("clock/center")[0]);
        this._hHand = new PIXI.Sprite(Game.assetLoader.getTextures("clock/hour")[0]);
        this._mHand = new PIXI.Sprite(Game.assetLoader.getTextures("clock/minutes")[0]);
        this._sHand = new PIXI.Sprite(Game.assetLoader.getTextures("clock/second")[0]);
        this._center.name = "center";
        this._hHand.name = "hour";
        this._mHand.name = "minutes";
        this._sHand.name = "seconds";
        this._center.anchor.set(0.5);
        this._hHand.anchor.set(1, 0.5);
        this._mHand.anchor.set(0, 0.5);
        this._sHand.anchor.set(0.5, 1);
        this.addChild(this._center, this._sHand, this._mHand, this._hHand);
    }
}